import returnBuyerType, { BuyerTypes } from '../helpers/returnBuyerType'
import type { SearchVehicle } from '../types'

export const buyerAgent = ({
    buyerAgentName,
    buyerLegacyId,
    buyerAgentId,
    buyerDisplayName,
}: SearchVehicle): string => {
    const buyerType = returnBuyerType({ buyerAgentId, buyerAgentName })
    const name = buyerType === BuyerTypes.Agents ? buyerAgentName?.toUpperCase() : buyerDisplayName
    const id = buyerLegacyId ? `(${buyerLegacyId})` : ''

    return `${name || ''} ${id}`
}
